export default __webpack_public_path__ + "static/live_attribute-11ac0758061effdae0ad091a5f9ce0cf.png";